@if (isAdmin) {
<div class="information-page cardWithShadow p-8 m-b-0 information-admin">
  <div class="information-header d-flex align-items-center p-16 pb-0! justify-content-between">
    <span class="f-s-16 f-w-600">{{ (informationId ? 'edit' : 'add') | translate }}</span>
    <div (click)="close()" class="w-8 aspect-square d-flex justify-content-center align-items-center rounded cursor-pointer hover:bg-[var(--mat-color-light-table-hover)] hover:text-[var(--mat-sys-primary)] dark:hover:bg-[var(--striped-row-background-color)] dark:hover:text-[var(--mat-color-primary)]">
      <i-tabler name="x" class="icon-20" />
    </div>
  </div>

  <form [formGroup]="informationForm" class="information-form" (ngSubmit)="save()">
    <div class="information-body p-14">
      <div class="information-editor-wrap">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'subject' | translate }}</mat-label>
          <input matInput formControlName="subject" maxlength="100" />
          @if (subjectControl.touched && subjectControl.hasError('required')) {
          <mat-error>{{ 'subject required' | translate }}</mat-error>
          }
        </mat-form-field>
        <quill-editor class="information-editor" theme="snow" formControlName="message" [modules]="quillModules"
          [sanitize]="false" [placeholder]="'information content placeholder' | translate" (onEditorCreated)="onEditorCreated($event)">
        </quill-editor>
        @if (messageControl.touched && messageControl.hasError('required'))
        {
        <mat-error class="f-s-12 m-t-8">{{ 'information content required' | translate }}</mat-error>
        }
      </div>
    </div>
    <div class="d-flex justify-content-end p-14 p-t-0">
      <app-form-button [spinLoader]="spinLoader" [btnConfig]="saveButtonConfig" />
    </div>
  </form>
</div>
} @else {
<div class="border border-gray-300 rounded-[12px]">
  <div class="information-header d-flex align-items-center p-16 pb-0! justify-content-end">
    <div (click)="close()" class="w-8 aspect-square d-flex justify-content-center align-items-center rounded cursor-pointer hover:bg-[var(--mat-color-light-table-hover)] hover:text-[var(--mat-sys-primary)] dark:hover:bg-[var(--striped-row-background-color)] dark:hover:text-[var(--mat-color-primary)]">
      <i-tabler name="x" class="icon-20" />
    </div>
  </div>
  <div class="border-b border-gray-200 pb-7 px-8">
    <div class="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-1">{{ 'subject' | translate }}</div>
    <h2 class="information-subject-preview f-s-20 f-w-600 m-b-12 break-all leading-snug">{{ information.subject }}</h2>
    <div class="flex items-center gap-2 text-sm text-gray-500">
      <i-tabler name="calendar-event" class="icon-16 theme-icon shrink-0"></i-tabler>
      <p class="m-0"><span class="mr-[10px]">{{ 'created' | translate }}</span> <strong>{{ information.createdDate }}</strong></p>
    </div>
  </div>
  <div class="px-8 pb-6">
    <div class="text-xs font-semibold uppercase tracking-wider text-gray-400 my-4">{{ 'content' | translate }}</div>
    <div class="ql-snow information-preview-panel cursor-pointer" (click)="onPreviewClick($event)">
      <div class="ql-editor information-preview-content p-0!">
        <app-html-formatter [htmlText]="information.message" />
      </div>
    </div>
  </div>
</div>
}